import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { generateBarcodeReportSchema } from 'utils/schema/generateBarcodeReportSchema'
import toast from 'react-hot-toast'
import { DateTime } from 'components/common/input/dateTime'
import { Button } from 'components/common'
import { downloadUpdatedErpPriceReport } from 'utils/api/pricingApi'

type GenerateBarcodeReportType = {
  from: string
  to: string
}
const generateUpdatedErpPriceReport = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<GenerateBarcodeReportType>({
    resolver: yupResolver(generateBarcodeReportSchema),
  })

  const onSubmit = async (data: any) => {
    const loadingToast = toast.loading('Loading...', { duration: Infinity })

    const from = `${data.from}T00:00:00.000Z`
    const to = `${data.to}T23:59:59.999Z`

    await downloadUpdatedErpPriceReport({
      filters: {
        from,
        to,
      },
    })

    toast.success('File will be sent to you in email!', {
      id: loadingToast,
      duration: 3000,
    })
  }
  return (
    <div>
      <h3 className="title">Generate Updated Erp Price Barcode Report</h3>

      <form
        onSubmit={handleSubmit(onSubmit)}
        className="mb-5 flex items-end gap-4"
      >
        <DateTime
          required
          label="From"
          name="from"
          register={register}
          error={errors.from?.message}
        />
        <DateTime
          required
          label="To"
          name="to"
          register={register}
          error={errors.to?.message}
        />
        <Button
          className="mb-2 h-max"
          type="submit"
          variant="outline"
          buttonText="Generate"
        />
      </form>
    </div>
  )
}
export default generateUpdatedErpPriceReport
